export function FolderOpen() {
  return (
    <path fill="currentColor" d="M4.5 19q-.633 0-1.066-.434T3 17.5V6.615q0-.632.491-1.124Q3.983 5 4.615 5h4.981l2 2h7.789q.517 0 .902.28t.54.72H4v9.385q0 .211.106.346t.279.23l2.265-7.576h16.215l-2.267 7.555q-.142.477-.545.769q-.403.291-.9.291z"></path>
  )
}